import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Api } from '@carrier/utils/Api';

export const fetchAmbestRecords = createAsyncThunk(
  'ambest/fetchAmbestRecords',
  async (params, { getState, rejectWithValue }) => {
    try {
      const { page = 1, search = '', forceRefresh = false } = params || {};
      const { ambestCache } = getState().ambest;

      const cacheKey = `${page}_${search}`;

      if (ambestCache[cacheKey] && !forceRefresh) {
        return {
          ...ambestCache[cacheKey],
          cacheKey,
          currentPage: page,
          searchQuery: search
        };
      }
      const apiParams = { page };

      if (search) apiParams.name = search;

      const { data, headers } = await Api.loadAmbestRecords(apiParams);
      const pagination = headers['x-pagination'] ? JSON.parse(headers['x-pagination']) : {};

      return {
        data,
        pagination,
        cacheKey,
        currentPage: page,
        searchQuery: search
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch AMBest records');
    }
  }
);

const initialState = {
  ambestRecords: [],
  ambestCache: {},
  pagination: {},
  loading: false,
  error: null,
  currentPage: 1,
  searchQuery: ''
};

const ambestSlice = createSlice({
  name: 'ambest',
  initialState,
  reducers: {
    clearCache: state => {
      state.ambestCache = {};
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAmbestRecords.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAmbestRecords.fulfilled, (state, action) => {
        const { data, pagination, cacheKey, currentPage, searchQuery } = action.payload;

        state.ambestRecords = data;
        state.pagination = pagination;
        state.ambestCache[cacheKey] = { data, pagination };
        state.currentPage = currentPage;
        state.searchQuery = searchQuery;
        state.loading = false;
      })
      .addCase(fetchAmbestRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearCache, setSearchQuery, setCurrentPage } = ambestSlice.actions;
export default ambestSlice.reducer;
